<template>
  <div class="app-container">
    <el-form :model="queryParams" class="multipleSelectScroll" ref="queryForm" v-show="showSearch" label-width="80px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="订单编号" prop="orderNum">
            <el-input v-model="queryParams.orderNum" placeholder="请输入服务订单编号" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="queryParams.customerName" placeholder="请输入客户名称" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="客户性质" prop="customerNatureList">
            <el-select v-model="queryParams.customerNatureList" placeholder="请选择客户性质" clearable multiple style="width:100%">
              <el-option v-for="dict in natureOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="订单状态" prop="orderStatusList">
            <el-select v-model="queryParams.orderStatusList" placeholder="请选择订单状态" clearable multiple style="width:100%">
              <el-option v-for="dict in statusOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="交付订单" prop="deliveryOrderNum">
            <el-input v-model="queryParams.deliveryOrderNum" placeholder="请输入交付订单编号" clearable/>
          </el-form-item>
        </el-col>
        <dept-user-select ref="deptUserSelectRef" :formParam="queryParams" @auto-selected="handleQuery" :autoSelectUser="autoSelectUser"></dept-user-select>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="处理日期" prop="dealDate">
            <el-date-picker v-model="queryParams.dealDate" value-format="yyyy-MM-dd" type="daterange" range-separator="-" style="width:100%" start-placeholder="开始日期" end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="问题类型" prop="problemJudgeList">
            <el-select v-model="queryParams.problemJudgeList" placeholder="请选择订单状态" clearable multiple style="width:100%">
              <el-option v-for="dict in prombleOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="24" :lg="24" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-user" :disabled="multiple" @click="handleAssign">分配</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>
    <el-row :gutter="10">
      <div style="font-size: 14px; margin: 10px; display: inline-block">
        订单数量：{{ total }}
      </div>
      <div style="font-size: 14px; margin: 10px 10px 10px 30px; display: inline-block">
        服务费用汇总（元）：{{ amountFormat(Number(otherData.totalServiceFee || 0)) }}元
      </div>
    </el-row>
    <el-table v-loading="loading" :data="dataList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" fixed="left" align="center"/>
      <el-table-column label="订单编号" align="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="$jump.service(scope.row.id, '_blank')">{{scope.row.orderNum}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="订单状态"  align="left" prop="orderStatusDesc">
      </el-table-column>
      <el-table-column label="客户" align="center" prop="businessLevelDesc">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="$jump.customer(scope.row.customerId, '_blank')">{{scope.row.customerName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="客户性质" align="center" prop="customerNature"/>
      <el-table-column label="交付订单" align="center" prop="deliveryOrderNum">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="$jump.deliver(scope.row.deliveryOrderId, '_blank')">{{scope.row.deliveryOrderNum}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="问题类型" align="center" prop="problemJudges"/>
      <el-table-column label="服务费用(元)" align="center" prop="estimateDealAmount">
        <template slot-scope="scope">
          <span v-if="scope.row.serviceFee !== 0">{{ amountFormat(Number(scope.row.serviceFee || 0)) }}元</span>
          <span v-else>免费</span>
        </template>
      </el-table-column>
      <el-table-column label="问题日期" align="center" prop="problemHappenDate"/>
      <el-table-column label="处理日期" align="center" prop="dealDate">
      </el-table-column>
      <el-table-column label="负责人"align="center" prop="managerName"/>
      <el-table-column label="操作" width="90" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="text"  @click="toDetail(scope.row)">查看</el-button>
          <el-button v-if="scope.row.orderStatus === 10" type="text"  @click="handleResolve(scope.row)">处理</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList"/>

    <AssignDialog ref="assignDialogRef" @success="getList"></AssignDialog>
    <!-- 新增服务单 -->
    <ServiceOrderAddDialog ref="serviceOrderAddDialogRef" @success="getList"></ServiceOrderAddDialog>
    <!-- 处理服务单 -->
    <ResolveServiceDialog ref="resolveServiceDialogRef" @success="getList"></ResolveServiceDialog>
  </div>
</template>

<script>
import UserSelect from "@/views/crm/components/userSelect";
import AssignDialog from "@/views/crm/components/assignDialog";
import ServiceOrderAddDialog from "./serviceOrderAddDialog";
import ResolveServiceDialog from "./resolveServiceDialog";
import {queryListBusiness} from "@/api/crm/business";
import { queryDefaultTemplateStage } from "@/api/crm/template";
import { mapState } from 'vuex'
import { amountFormat } from '@/utils/index'
import {changeStatus} from "@/api/crm/focus";
import deptUserSelect from "@/views/crm/components/deptUserSelect";
import { getDicts } from "@/api/system/dict/data";
import { listServiceByPage } from "@/api/crm/order";
import ScrollPane from "@/layout/components/TagsView/ScrollPane";

export default {
  name: "BusinessManage",
  data() {
    return {
      amountFormat,
      autoSelectUser: true,
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      dataList: [],
      otherData: {},
      statusOptions: [], // 订单状态
      businessStageOptions: [],
      businessLevelOptions: [],
      businessScaleOptions: [],
      prombleOptions: [],
      natureOptions: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderNum: null,
        customerName: null,
        customerNatureList: [],
        orderStatusList: [],
        deliveryOrderNum: null,
        dealDate: [],
        problemJudgeList: [],
        deptIdList: [],
        managerIdList: []
      }
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    ScrollPane,
    UserSelect,
    AssignDialog,
    ServiceOrderAddDialog,
    ResolveServiceDialog,
    deptUserSelect
  },
  created() {
    // this.getList(); // 改为选中后查询
    // delivery_order_status 交付单状态
    this.getDicts("service_order_status").then(response => {
      this.statusOptions = response.data;
    });
    this.getDicts("problem_judge").then(response => {
      this.prombleOptions = response.data;
    });
    this.getDicts("customer_nature").then(response => {
      this.natureOptions = response.data;
    });
    let jumpParams = this.$route.query // 客户详情交付单列表跳转带参
    if(Object.keys(jumpParams).length){
      this.autoSelectUser = false
      this.queryParams.deliveryOrderNum = jumpParams.deliveryOrderNum
      this.queryParams.deptIdList = []
      this.queryParams.managerIdList = []
    }
  },
  methods: {
    getList() {
      this.loading = true;
      let params = JSON.parse(JSON.stringify(this.queryParams));
      let dealDate = this.queryParams.dealDate
      listServiceByPage({
        ...params,
        dealDateStart: dealDate ? dealDate[0] : null,
        dealDateEnd: dealDate ? dealDate[1] : null
      }).then(response => {
          this.dataList = response.rows || []
          this.otherData = response.otherData || {}
          this.total = response.total;
          this.loading = false;
        }
      ).catch(error => {
        this.loading = false;
      });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.queryParams.deliveryOrderNum = null
      this.$router.replace({ query: {} })
      this.$refs.deptUserSelectRef.deptSelect()
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.multiple = !selection.length;
    },
    /** 详细按钮操作 */
    toDetail(row) {
      window.open("/crm/serviceOrder/detail/" + row.id, "_blank")
    },
    /** 详细按钮操作 */
    toCustomerDetail(row) {
      window.open("/crm/customer/detail/" + row.customerId, "_blank")
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.$refs.serviceOrderAddDialogRef.open();
    },
    /** 处理操作 */
    handleResolve(row) {
      this.$refs.resolveServiceDialogRef.open(row.id, row.dealDate, row.dealRemark);
    },
    /** 分配按钮操作 */
    handleAssign() {
      this.$refs.assignDialogRef.batchAssign("serviceOrder", this.ids)
    },
  }
};
</script>
